<!--
 * @Autor: Baowang
 * @Date: 2024-11-19 10:48:22
 * @pageName: 主页面头部
 * @LastEditTime: 2024-11-22 17:55:55
-->
<template>
  <div>
    <div class="public_top">
      <div class="public_top_left animate__animated animate__fadeInLeft">
        <div class="left_img">
          <el-image class="image_one" :src="require('../../assets/public_top_logo.png')" fit="fill"></el-image>
        </div>
        <div class="left_nav animate__animated animate__fadeInLeft">
          <div class="left_nav_one mouseGestures" :class="{ left_nav_oneactive: $store.state.navTopindex == index }" v-for="(item, index) in navArray" :key="index" @click="goNav(item, index)">
            {{ item.name }}
          </div>
        </div>
        <div class="public_top_input">
          <el-input class="input_one" v-model="keywords" :clearable="false" prefix-icon="el-icon-search" placeholder="请输入内容">
            <template slot="suffix" v-if="keywords">
              <div class="input_count mouseGestures" @click="search">搜索</div>
            </template>
          </el-input>
        </div>
      </div>

      <el-dropdown v-if="userInfo && userInfo.user_id">
        <span class="el-dropdown-link">
          <div class="public_top_righttwo mouseGestures animate__animated animate__fadeInRight">
            <img :src="userInfo.avatar" alt="" />
            {{ userInfo.nickname }}
          </div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <div @click="goMine">
              个人中心
            </div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="logout">
              退出登录
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>


      <div class="public_top_right mouseGestures animate__animated animate__fadeInRight" @click="openLogin" v-else>
        登录/注册
      </div>
    </div>

    <!-- 登录弹框 -->
    <loginVue />
    <!-- 忘记密码 -->
    <forgetpass />
    <!-- 注册弹框 -->
    <registered />
  </div>
</template>
<script>
import { mapState } from "vuex";
import loginVue from "@/components/loginMoudel/login.vue"; //登录模块
import forgetpass from "@/components/loginMoudel/forgetpass.vue"; //忘记模块
import registered from "@/components/loginMoudel/registered.vue"; //注册模块
export default {
  components: { loginVue, forgetpass, registered },
  data() {
    return {
      navArray: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "全部课程",
          path: "/allCourses",
        },
        {
          name: "会员中心",
          path: "/member",
        },
      ],
      navIndex: 0,
      keywords: "", //输入框
    };
  },
  computed: {
    ...mapState(["keyword", "userInfo"]),
  },
  watch: {
    keyword: {
      handler(newValue) {
        this.keywords = newValue;
        // console.log(newValue, "监听变换的值");
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    //路由跳转
    goNav(item, index) {
      this.$store.commit('upDatetopindex', index)
      if (item.path == '/member') {
        if (!this.$store.state.userInfo || !this.$store.state.userInfo.user_id) {
          this.$store.commit("updataLogin", true);
          return
        }
      }
      this.$router.push(item.path);
    },
    openLogin() {
      // 打开登录弹框
      this.$store.commit("updataLogin", true);
    },
    search() {
      // 点击搜索跳转搜索结果页面
      if (this.$route.path != "/searchResult") {
        // 如果不在搜索页面，跳转搜索页面
        this.$store.commit("updataKeyword", this.keywords);
        this.$router.push({ name: "searchResult" });
      } else {
        // 如果在搜索页面，则在当前页面搜索
        this.$store.commit("updataKeyword", this.keywords);
      }
    },
    goMine() {
      // 跳转个人资料
      this.$router.push("/minePage");
    },
    // 退出登录
    logout() {
      this.$store.commit("updateMe", {});
      this.$store.commit('upDatetopindex', 0)
      localStorage.removeItem('bzysPcUser');
      this.$router.push("/");
    },
    // 校验登录
    checkAuth() {
      if (!this.userInfo || !this.userInfo.user_id) {
        this.$store.commit("updataLogin", true);
        return
      }
    }
  },
};
</script>
<style lang="less" scoped>
.public_top {
  width: 100%;
  height: 96px;
  background-color: #ffffff;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 999;
  box-sizing: border-box;
  padding: 0 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .public_top_left {
    height: 40px;
    display: flex;
    align-items: center;

    .image_one {
      width: 140px;
      height: 40px;
      margin-right: 80px;
    }

    .left_nav {
      display: flex;
      align-items: center;

      .left_nav_one {
        height: 48px;
        line-height: 48px;
        text-align: center;
        margin-right: 30px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #29292b;
      }

      .left_nav_oneactive {
        color: #ff65c5;
      }

      // .left_nav_one:last-child {
      //   margin-right: 0;
      // }
      .left_nav_one:hover {
        color: #ff65c5;
      }
    }

    .public_top_input {
      .input_one {
        width: 338px;
        height: 48px;
        display: flex;
        align-items: center;

        /deep/ .el-input__inner {
          box-sizing: border-box;
          padding-right: 80px;
        }

        .input_count {
          width: 60px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          background: #80d3be;
          border-radius: 22px;
          font-family: PingFang SC, PingFang SC;
          font-weight: normal;
          font-size: 14px;
          color: #ffffff;
          margin-top: 10px;
        }
      }
    }
  }

  .public_top_right {
    width: 120px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    background: #00a87d;
    border-radius: 12px;
    font-family: PingFang SC, PingFang SC;
    font-weight: normal;
    font-size: 16px;
    color: #ffffff;
  }

  .public_top_righttwo {
    display: flex;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 20px;
    }

    font-family: PingFang SC,
    PingFang SC;
    font-weight: normal;
    font-size: 16px;
    color: #29292b;
  }
}
</style>
